module.exports = __webpack_public_path__ + "img/logo3.5eb8bd42.png";